import { createRoot } from "react-dom/client";
import HotelCarousel from "./HotelCarousel";

const root = document.getElementById("hotel-carousel-root");

if (root) {
  createRoot(root).render(<HotelCarousel />);
}

export default HotelCarousel;
